import React, { useState, useEffect, useRef, useCallback, Suspense } from "react";
import { Provider } from "react-redux";
import AppStore from "../requests/redux/store";
import { ApplicantProfile, ATSWrapper, Kanban, OutlookWrapper, SuspendModal, DeleteModal, OptionModal, ActivateModal, GoogleWrapper, SuccessNotification, CandidatesCopyModalConponent, ModalCreateCandidate, WorkflowConfigurationSelectorModal} from "@rankmi/ats-app";
import humps from "humps";
import _ from 'lodash';
import "antd/dist/antd.css";
import { FormEmployeeRegistration } from "@rankmi/all-in-one-components/lib/FormEmployeeRegistration";
import { RegisterEmployeesForm } from "@rankmi/all-in-one-components/lib/RegisterEmployees";
import "@rankmi/rankmi-styles/dist/css/reset-ant/main.css";
import "@rankmi/rankmi-components/dist/index.css";
import "@rankmi/ats-app/dist/index.css";
import ModalUserColumns from "@fcomponents/lists/modal_user_columns/ModalUserColumns";
import "./ATSKanbanNew.module.scss";
import ClosingProcessReasonModal from "@frontend/components/selection_processes/closing_process_reason_modal/ClosingProcessReasonModal";
import ClosingReasonForm from "@frontend/components/selection_processes/closing_reason_form/ClosingReasonForm";
import { ClosingReasonService } from "@frontend/src/core/services/closing_reason_service";
import { SelectionProcessesService } from "@frontend/src/core/services/selection_processes_service";
import { createTransactionalMovementsReport } from "@frontend/src/core/services/transactional_movements_report_service";
import { EducationService } from "../../src/core/services/education_service";
import { openNotificationWithIcon } from "@frontend/src/utilities/notificationWithIcon";
import {
  APPLICANTS_ACTIONS,
  SELECTION_PROCESSES_STATUSES,
} from "@frontend/constants/initialValues";
import { ApplicantsService } from "@frontend/src/core/services/applicants_service";
import { workflowsService } from "@frontend/src/core/workflows/workflows_service";
import { AIO_HIRING_WORKFLOW_APP_MODULE_NAMES } from "@frontend/src/core/workflows/hiring_workflow_app_modules";
import FiltersViewerModal from "../Modals/FiltersViewerModal";
import { RequestModal, RequestModalExternal } from "@rankmi/workflows-app";
import { config } from "@frontend/constants/outlook_config";
import { OrganizationService } from "@frontend/src/core/services/organization_sevice";
import { FormOptionalSection } from "@rankmi/rankmi-optionals";
import { ModalPositionInfo } from '@rankmi/all-in-one-components/lib/ModalPositionInfo'
import { getTimeFrom } from "@frontend/helpers/formatDate";
import moment from 'moment'
// FOR WORKFLOWS VIEWER
import { RequestProfileComponent } from "@fcomponents/molecules/RequisitionFormViewer";
import "@rankmi/all-in-one-components/lib/style.css";

const PersonnelRegistrationFormViewer = ({
  type,
  dispatchUpdate,
  showApproveButton,
  showCloseButton,
  showRejectButton,
  showDerivateButton,
  showSubmitButton,
  onCancel,
  onSubmit,
  onReject,
  onDeriveChanges,
  disabled,
  entry,
  structure,
  optionalComponent
}) => {
  return (
    <FormEmployeeRegistration
      showApproveButton={showApproveButton}
      showCloseButton={showCloseButton}
      showDerivateButton={showDerivateButton}
      showRejectButton={showRejectButton}
      showSubmitButton={showSubmitButton}
      onCancel={onCancel}
      onSubmit={onSubmit}
      onReject={onReject}
      onDeriveChanges={onDeriveChanges}
      type={type}
      dispatchUpdate={dispatchUpdate}
      disabled={disabled}
      entry={entry}
      origin="ats"
      structure={structure}
      optionalComponent={optionalComponent}
    />
  );
};

/**
 * New component for RegisterEmployeesForm Viewer (Mexico)
 * @param {*} props
 * @returns
 */
const RegisterEmployeesFormViewer = (props) => {
  return (
    <RegisterEmployeesForm classWrapperName="ATS" {...props} />
  )
}

const ATSKanbanNew = ({
  selectionProcess: {
    id = 0,
    title = "",
    testsAvailable,
    status = {},
    geniusActivation = false,
    testActivation = false,
    assessmentId,
    position,
    hasLimitRegisterApplicants = false
  },
  creator,
  workflowId,
  area,
  createdAt,
  statusColor,
  currentUser,
  userRole,
  mettlActive,
  applicantSections,
  hasAccess,
  appId,
  googleClientId,
  canUseSegments,
  externalConnectionsExpired
}) => {
  const [showSuspendModal, setSuspendModal] = useState(false);
  const [participant, setParticipant] = useState();
  const [contratationData, setContratationData] = useState();
  const [showUserColumn, setShowUserColumn] = useState();
  const [selectedColumn, setSelectedColumn] = useState();
  const [closingReasons, setClosingReasons] = useState([]);
  const [showCloseReasonModal, setShowReasonModal] = useState(false);
  const [copyModal, setCopyModal] = useState(false);
  const [moveModal, setMoveModal] = useState(false);
  const [bulkMoveModal, setBulkMoveModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [activateModal, setActivateModal] = useState(false);
  const [requestModal, setRequestModal] = useState(false);
  const [positionModal, setPositionModal] = useState(false);
  const [rules, setRules] = useState({});
  const [rulesTest, setRulesTest] = useState({});
  const [showFiltersOnly, setShowFiltersOnly] = useState(false);
  const [activateLoading, setActivateLoading] = useState(false);
  const closingReasonService = new ClosingReasonService();
  const selectionProcessService = new SelectionProcessesService();
  const [hasSignature, setHasSignature] = useState(false);
  const statusName = SELECTION_PROCESSES_STATUSES[status.id];
  const closedProcess = statusName === "CERRADO";
  const currentUserIsAdmin = currentUser.is_admin || userRole == "admin";
  const organizationService = new OrganizationService();
  const educationService = new EducationService();
  const [applicantForm, setApplicantForms] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showRequestTypeSelectorModal, setShowRequestTypeSelectorModal] = useState(false);
  const [requestTypesOptions, setRequestTypesOptions] = useState([]);
  const [pendingApplicant, setPendingApplicant] = useState(null);
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [applicantProfileState, setApplicantProfileState] = useState(null)
  const [applicantsIds, setApplicantdIds] = useState([])
  const [addNewCandidateModalOpen, setAddNewCandidateModalOpen] = useState(false);
  const [transactionalReportLoading, setTransactionalReportLoading] = useState(false);
  const [kanbanSize, setKanbanSize] = useState('M');
  const [selectionProcessesList, setSelectionProcessesList] = useState([]);
  const listRefreshRef = useRef(null);
  const kanbanDescription = document.querySelector('._3AitL')
  const handleSize = () => {

    const kanbanContainerColumns = document.querySelector('._3707P')
    if(kanbanDescription && kanbanContainerColumns) {
      const kanbanDescriptionHeight = kanbanDescription.offsetHeight + 95
      const calculatedHeight = `calc(100vh - ${kanbanDescriptionHeight}px)`
      kanbanContainerColumns.style.height = calculatedHeight
    }
  }

  useEffect(() => {
    handleSize()
    window.addEventListener('resize', handleSize)
    return () => window.removeEventListener('resize', handleSize)
  }, [kanbanDescription])

  useEffect(() => {
    organizationService.providers(hasSignatureProvider, console.error);
    educationService.getUniversities(
      { items: 20 },
      (res) => {handleUniversities(res.data)},
      console.error
    )

    fetchRuleElements();
    sessionStorage.removeItem('profile_active_tab')
    sessionStorage.removeItem('profile_drawer_width')
    const kanbanSizeValue = sessionStorage.getItem('ats_kanban_size')
    if (kanbanSizeValue) {
      setKanbanSize(kanbanSizeValue)
    }

    // Load selection processes list for move/copy modal via API
    selectionProcessService
      .getBasicInfoList(1, 10000, {})
      .then((data) => {
        const mapped =
          (data || [])
            .map((item) => [Number(item.id), item.attributes?.title])
            .filter(([, title]) => !!title)
        setSelectionProcessesList(mapped)
      })
      .catch(console.error)
  }, []);

  useEffect(() => {
    if(closingReasons.length === 0 && showCloseReasonModal)
      closingReasonService.getAll(setClosingReasons, console.error);
  }, [showCloseReasonModal]);

  useEffect(() => {
    if (mettlActive && Object.keys(rules).length > 0) {
      selectionProcessService.fetchRuleTestElements((data) => {
        let external = false
        if(data.length > 0) {
        const options = data.map((item) => {
          if (item.external_test) external = true

          return ({
            id: item.test_id,
            label: item.name,
            value: item.test_id,
            childrensGroup: item.dimentions,
          })

        })
        const newData = {
          ...rules,
          Pruebas: {
            value: "tests",
            type: "group",
            options: options,
            externalTests: external
          }
        }
        setRulesTest(newData);
        return
        }
        else {
          setRulesTest(rules)
        }
      }, console.error);
    }
  }, [rules]);

  useEffect(() => {
    if (!!contratationData) {
      setRequestModal(true);
    }
  }, [contratationData]);

  function hasSignatureProvider(providers) {
    const aux = providers.includes("Firma de documentos");
    setHasSignature(aux);
  }

  const handleFinish = (e, form) => {
    e.preventDefault();
    form.validateFields((_err, values) => {
      selectionProcessService.close(
        id,
        values,
        (_data) => {
          SuccessNotification('Proceso cerrado correctamente');
          window.location.href = `${window.location.protocol}//${window.location.host}/selection_processes`;
        },
        (err) => console.error(err)
      );
    });
  };

  const handleFormApplicant = (data) => {
    if (data.length === 0) return
    const manage_data = data
    const transformed_data = {}
    manage_data.forEach((item) => {
      item.form_optionals.forEach((element) => {
        if (element.value)
          transformed_data[element.code] = element.value
      }
    )})

    const result = Object.keys(transformed_data).map((key) => {
      return {
        name: key,
        code: transformed_data[key]
      }
    })

    setApplicantForms(result)
  }

  const handleContratationData = (data) => {
    setContratationData(data)
  }

  const handlePause = () => {
    selectionProcessService.supend(
      id,
      (_data) => {
        SuccessNotification('Proceso suspendido correctamente');
        window.location.href = `${window.location.protocol}//${window.location.host}/selection_processes`;
      },
      (err) => console.error(err)
    );
  };

  const handleActivate = () => {
    setActivateLoading(true)
    selectionProcessService.activate(
      id,
      (_data) => {
        SuccessNotification('Proceso activado correctamente')
        setTimeout(() => {
          location.reload()
        }, 1000);
      },
      (err) => {
        setActivateLoading(false)
        console.error(err)
      }
    );
  };

  const handleUniversities = (result) => {
    setUniversities(result.map((item) => {
      return {
        label: item.name,
        value: item.name
      }
    }))
  }

  const handleSearchUniversities = (value, selected = "") => {
    educationService.getUniversities(
      { items: 20, search: value, selected: selected },
      (res) => handleUniversities(res.data),
      console.error
    )
  }

  const fetchRuleElements = () => {
    selectionProcessService.fetchRuleElements(id, setRules, console.error);
  };

  const applicantsService = new ApplicantsService();

  /**
   * Normaliza y valida los request types de un participante
   * @param {Object} participant - El participante con su selectionProcess
   * @returns {Array|null} Array normalizado de request types o null si no hay
   */
  const normalizeRequestTypeData = (participant) => {
    const requestTypeData = participant?.selectionProcess?.requestTypeData || participant?.requestTypeData;

    if (!requestTypeData || (Array.isArray(requestTypeData) && requestTypeData.length === 0)) {
      return null;
    }

    return Array.isArray(requestTypeData) ? requestTypeData : [requestTypeData];
  };

  /**
   * Maneja el inicio del proceso de alta para un participante
   * @param {Object} participant - El participante seleccionado
   * @param {Function} onError - Callback para manejar errores
   */
  const handleStartHiring = (participant, onError = console.error) => {
    const normalizedRequestTypes = normalizeRequestTypeData(participant);

    if (!normalizedRequestTypes || normalizedRequestTypes.length === 0) {
      openNotificationWithIcon('error', 'No hay tipos de solicitud configurados para este proceso');
      return;
    }

    if (normalizedRequestTypes.length === 1) {
      // Si hay un solo request type, continuar directamente
      setParticipant({
        ...participant,
        requestTypeData: normalizedRequestTypes[0].id,
        uniqApplicantId: participant.uniqApplicant?.id
      });
      applicantsService.getApplicantForms(participant.id, handleFormApplicant, onError);
      applicantsService.getContratationData(participant.id, handleContratationData, onError);
    } else {
      // Si hay múltiples, mostrar selector
      setPendingApplicant(participant);
      setRequestTypesOptions(normalizedRequestTypes);
      setShowRequestTypeSelectorModal(true);
      // Limpiar participant.requestTypeData para que el selector empiece sin selección
      setParticipant({
        ...participant,
        requestTypeData: undefined,
        uniqApplicantId: participant.uniqApplicant?.id
      });
    }
  };

  const getCardsOptions = (onDisqualify, onSendTests, onSendDocumentIndividual, column, card) => {
    if (!column.permissions?.canEditRules || userRole === 'employee') return []
    let res = []

    const actions = [
      {
        label: "Copiar",
        type: "inProcess",
        onClick: (card) => handleSelected(card, APPLICANTS_ACTIONS[0]),
      },
      {
        label: "Mover",
        type: "inProcess",
        onClick: (card) => handleSelected(card, APPLICANTS_ACTIONS[1]),
      },
      {
        label: "Iniciar Alta",
        type: "inProcess",
        visible: !!card.requestTypeData &&
          card.canStartHiring &&
          (hasLimitRegisterApplicants ? column.permissions.canRegisterWorkflow : true),
        onClick: (card) => handleSelected(card, APPLICANTS_ACTIONS[3]),
      },
      {
        label: "Ver Alta",
        type: "inProcess",
        visible: !!card.requestTypeData && card.canSeeHiring,
        onClick: (card) => handleSelected(card, APPLICANTS_ACTIONS[4]),
      },
      {
        label: "Borrar",
        type: "inProcess",
        visible: column.permissions?.canDelete,
        onClick: (card) => handleSelected(card, APPLICANTS_ACTIONS[2]),
      },
      {
        label: "Enviar documento a firmar",
        type: "inProcess",
        visible: column.permissions?.canSendDocumentIndividual,
        testId: "menu-item-enviar-documento-firmar",
        onClick: (card) => onSendDocumentIndividual(card.id, 'signature'),
      },
      {
        label: "Enviar mensaje individual",
        type: "inProcess",
        visible: column.permissions?.canSendDocumentIndividual,
        testId: "menu-item-enviar-mensaje-individual",
        onClick: (card) => onSendDocumentIndividual(card.id, 'email'),
      }
    ];

    switch (statusName) {
      case "ACTIVO":
      case "PENDIENTE":
        res = actions
        break;

      case "SUSPENDIDO":
        res = [actions[1], actions[3]];
        break;

      case "CERRADO":
        res = [actions[0]];
        break;

      default:
        break;
    }
    return res
  };

  const getColumnOptions = (
    onDisqualify,
    onReactivate,
    onMoveMultiple,
    onSendTests,
    onSendEmail,
    onSendForm,
    onScheduleGoogle,
    onDeleteColumn,
    onScheduleOutlook,
    onSendDocument,
    selectedCards,
    column = {},
    currentTab
  ) => {
    if (closedProcess) return []
    const accessMenu = (column.permissions?.canSeeMenu || column.permissions?.canAccessList)
    const countCardsSelected = column.id && selectedCards[column.id] ? `(${selectedCards[column.id].length})` : '(0)'
    const actions = [
      {
        label: "Reglas de avance",
        visible: column.permissions?.canEditRules,
        onClick: (columnId) => {
          setSelectedColumn(columnId);
          setShowFiltersOnly(true);
        },
      },
      {
        label: "Configuraciones de etapa",
        visible: column.permissions?.canEditUserColumns,
        onClick: (columnId) => {
          setSelectedColumn(columnId);
          setShowUserColumn(true);
        },
      },
      {
        label: "Eliminar etapa",
        visible: column.permissions?.canDelete,
        onClick: (columnId) => {
          onDeleteColumn(columnId);
          setApplicantProfileState(null);
        },
      }
    ];
    const actionsWithCounter = [
      {
        label: `Mover de etapa ${countCardsSelected}`,
        visible: accessMenu,
        onClick: (columnId) => {
          !!selectedCards[columnId] &&
            onMoveMultiple(columnId, selectedCards[columnId]);
          !!selectedCards[columnId] && setApplicantProfileState(null);
        },
      },
      {
        label: `Mover de proceso ${countCardsSelected}`,
        visible: accessMenu,
        onClick: (columnId) => {
          !!selectedCards[columnId] &&
            onBulkMove(columnId, selectedCards[columnId]);
          !!selectedCards[columnId] && setApplicantProfileState(null);
        },
      },
      {
        label: `Enviar correo ${countCardsSelected}`,
        visible: accessMenu,
        onClick: (columnId) => {
          !!selectedCards[columnId] &&
            onSendEmail(columnId, selectedCards[columnId]);
        },
      },
      {
        label: `Enviar pruebas ${countCardsSelected}`,
        visible: accessMenu && testActivation && (testsAvailable.rankmi || testsAvailable.kudert),
        onClick: (columnId) => {
          !!selectedCards[columnId] &&
            onSendTests(columnId, selectedCards[columnId]);
        },
      },
      {
        label: `Enviar formulario ${countCardsSelected}`,
        visible: accessMenu,
        onClick: (columnId) => {
          !!selectedCards[columnId] &&
            onSendForm(columnId, selectedCards[columnId]);
        },
      },
      {
        label: `Descalificar ${countCardsSelected}`,
        visible: accessMenu && !(currentTab === "disqualified"),
        onClick: (columnId) => {
          !!selectedCards[columnId] &&
            onDisqualify(columnId, selectedCards[columnId]);
          !!selectedCards[columnId] && setApplicantProfileState(null);
        },
      },
      {
        label: `Reactivar ${countCardsSelected}`,
        visible: accessMenu && currentTab === "disqualified",
        type: "disqualified",
        onClick: (columnId) => {
          !!selectedCards[columnId] &&
            onReactivate(columnId, selectedCards[columnId]);
          !!selectedCards[columnId] && setApplicantProfileState(null);
        },
      },
      {
        label: `Enviar documentos a firmar ${countCardsSelected}`,
        visible: accessMenu && hasSignature && column.permissions?.canSendEmail,
        onClick: (columnId) => {
          !!selectedCards[columnId] &&
            onSendDocument(columnId, selectedCards[columnId]);
        },
      },
    ];
    return selectedCards[column.id]
      ? [...actions, ...actionsWithCounter]
      : actions;
  };

  const requestTransactionalMovementsForCurrentProcess = async () => {
    if (transactionalReportLoading) return;
    setTransactionalReportLoading(true);
    try {
      const { data } = await createTransactionalMovementsReport({
        selection_process_ids: [id],
      });
      const toastMessage = data?.message || "Solicitud enviada.";
      openNotificationWithIcon("success", toastMessage, "", 4);
    } catch (err) {
      const status = err.response?.status;
      const msg =
        err.response?.data?.message ||
        err.message ||
        "No se pudo solicitar el reporte.";
      const title =
        status === 403
          ? "Sin permisos"
          : status === 422
            ? "Solicitud inválida"
            : "Error";
      openNotificationWithIcon("error", title, msg, 6);
    } finally {
      setTransactionalReportLoading(false);
    }
  };

  const getActionsOptions = (showAplicantsModal, setShowTagsModal) => {
    if (!hasAccess) return [];

    let res = [];

    const transactionalMovementsReportAction = {
      label: "Reporte de Temporalidad",
      disabled: transactionalReportLoading,
      onClick: () => requestTransactionalMovementsForCurrentProcess(),
    };

    const actions = [
      {
        label: "Agregar candidatos",
        onClick: () => {
          if(currentUserIsAdmin || canUseSegments) {
            setAddNewCandidateModalOpen(true)
          } else {
            window.location.href = `${window.location.href.split("/new")[0]
              }/applicants/new`
          }
        }
      },
      {
        label: "Compartir proceso",
        onClick: () =>
        (window.location.href = `${window.location.href.split("/new")[0]
          }/publish`),
      },
      {
        label: "Editar proceso",
        onClick: () =>
        (window.location.href = `${window.location.href.split("/new")[0]
          }/edit`),
      },
      {
        label: "Exportar candidatos",
        onClick: () =>
        (window.location.href = `${window.location.href.split("/new")[0]
          }/export_applicants.xlsx`),
      },

      {
        label: "Importar candidatos",
        onClick: () => showAplicantsModal("general"),
      },
      {
        label: "Importar candidatos desde Yapo",
        onClick: () => showAplicantsModal("yapo"),
      },
      {
        label: "Cerrar proceso",
        onClick: () => setShowReasonModal(true),
      },
      {
        label: "Suspender proceso",
        onClick: () => setSuspendModal(true),
      },
      {
        label: "Añadir etiquetas",
        onClick: () => setShowTagsModal(true),
      }
    ];

    const activate = {
      label: "Activar proceso",
      onClick: () => setActivateModal(true),
    };

    const reactivate = {
      label: "Reactivar proceso",
      onClick: () => setActivateModal(true),
    };

    const positionOption = {
      label: "Ver información de posición",
      onClick: () => setPositionModal(true),
    }

    switch (statusName) {
      case "ACTIVO":
        res = actions
        break;

      case "SUSPENDIDO":
        res = [actions[3], reactivate, actions[6]]
        break;

      case "CERRADO":
        res = currentUserIsAdmin ? [actions[3], reactivate] : [actions[3]]
        break;

      case "PENDIENTE":
        res = [activate]
        break;

      default:
        break;
    }

    if (position?.value) {
      res.splice(3, 0, positionOption)
    }

    if (currentUserIsAdmin && res.length > 0) {
      res = [...res, transactionalMovementsReportAction];
    }

    return res
  };

  const buildTags = () => {
    const results = [
      { label: `ID: ${id}`, icon: "fingerprint" },
      { label: creator, icon: "user" },
      { label: getTimeFrom(moment(createdAt).locale('es')), icon: "calendar", tooltip: { title: moment(createdAt).format("DD/MM/YYYY")} },
    ];
    workflowId && results.push({ label: workflowId, icon: "code-branch" });
    area && results.push({ label: area, icon: "sitemap" });
    return results;
  };

  const handleSelected = (selectedParticipant, type) => {
    setParticipant(selectedParticipant);
    if (applicantProfileState !== null) {
      setApplicantProfileState(null);
    }
    switch (type) {
      case APPLICANTS_ACTIONS[0]:
        setCopyModal(true);
        break;
      case APPLICANTS_ACTIONS[1]:
        setMoveModal(true);
        break;
      case APPLICANTS_ACTIONS[2]:
        setDeleteModal(true);
        break;
      case APPLICANTS_ACTIONS[3]:
        handleStartHiring(selectedParticipant);
        break;
      case APPLICANTS_ACTIONS[4]:
        setShowRequestModal(true)
        break;
      default:
        break;
    }
  };

  const handleMove = (id) => {
    applicantsService.move(
      participant.id,
      { selection_process_id: id },
      () => {
        setMoveModal(false)
        SuccessNotification('Candidato movido correctamente')
        window.location.href = `${window.location.origin}/selection_processes/${id}`;
      },
      () => {
        openNotificationWithIcon("error", "Ocurrió un error")
      }
    );
  };

  const onBulkMove = (columnId, selectedCards) => {
    setSelectedApplicants(selectedCards)
    setBulkMoveModal(true);
  };

  const handleBulkMove = (selection_process_id) => {
    selectionProcessService.bulkMove(
      id,
      { target_selection_process_id: selection_process_id,
        applicant_ids: selectedApplicants
      },
      () => {
        setBulkMoveModal(false)
        SuccessNotification('Los candidatos seran movidos en breve, espere unos minutos para que aparezcan en el proceso destino')
        setTimeout(() => {
          window.location.href = `${window.location.origin}/selection_processes/${id}`;
        }, 2000);
      },
      (error) => {
        openNotificationWithIcon("error", error.response.data.message)
        setBulkMoveModal(false)
        setTimeout(() => {
          window.location.href = `${window.location.origin}/selection_processes/${id}`;
        }, 3000);
      }
    );
  };

  const handleDelete = () => {
    applicantsService.deleteApplicant(
      participant.id,
      () => {
        setDeleteModal(false)
        SuccessNotification('Candidato eliminado correctamente')
        window.location.href = `${window.location.origin}/selection_processes/${id}`;
      },
      () => openNotificationWithIcon("error", "Ocurrió un error")
    );
  };

  const handleStartRequest = (response) => {
    if (response?.externalReference === participant.id) {
      workflowsService.fetchWorkflowsConfig(
        (data) => updateApplicant(data, response),
        (error) => {
          console.error('Error fetching workflows config:', error);
          openNotificationWithIcon('error', 'Error al obtener la configuración del workflow');
        }
      );
    }
  };

  const updateApplicant = (entryData, response) => {
    const appModuleName = entryData.find((elem) => elem.id === participant?.requestTypeData)?.app_module?.name;
    const validHiring = AIO_HIRING_WORKFLOW_APP_MODULE_NAMES.includes(appModuleName);
    const data = {
      workflow_id: response.id,
      sending_documents: hasSignature && validHiring,
      uniq_applicant_token: contratationData.v2?.token
    };
    applicantsService.updateById(
      participant.id,
      data,
      'application/json',
      () => SuccessNotification('Alta solicitada correctamente'),
      () =>
        openNotificationWithIcon(
          "error",
          "Ocurrió un error, intenta nuevamente.",
          ""
        )
    );
    setRequestModal(false)
  }

  /**
   * Obtiene los IDs de los candidatos para la paginación del perfil
   * @param {Object} selectedApplicant - El candidato seleccionado
   * @returns {Array|undefined} Array de IDs o undefined si no hay datos
   */
  const handleApplicantIds = (selectedApplicant) => {
    if (applicantsIds) {
      const columnData = applicantsIds.find(({ id }) => id === selectedApplicant.column);
      if (columnData) {
        return columnData.cards
          .map((item) => item.status === selectedApplicant.status && item.id)
          .filter(Boolean);
      }
    }
    return undefined;
  };

  const handleApplicantMutated = useCallback(({ stageId, previousStageId }) => {
    const stageIds = [stageId];
    if (
      previousStageId != null &&
      String(previousStageId) !== String(stageId)
    ) {
      stageIds.push(previousStageId);
    }
    listRefreshRef.current?.(stageIds);
  }, []);

  const handleListRefreshReady = useCallback((refresh) => {
    listRefreshRef.current = refresh;
  }, []);

  return (
    <div style={{ width: "97%" }} data-testid="ATSKanban">
      <Suspense fallback={""}>
        <GoogleWrapper clientId={googleClientId}>
          <OutlookWrapper config={{ ...config, appId: appId[0]?.data?.app_id }}>
            <Kanban
              actionsOptions={getActionsOptions}
              cardOptions={getCardsOptions}
              columnOptions={getColumnOptions}
              canEditTags={currentUserIsAdmin}
              processId={id}
              onListRefreshReady={handleListRefreshReady}
              processInfo={{
                name: title,
                tags: buildTags(),
                stateColor: statusColor,
                assessmentId: assessmentId,
                externalConnection: {
                  expired: externalConnectionsExpired,
                  showButton: currentUserIsAdmin,
                  url: `${window.location.origin}/selection_processes/${id}/publish`
                }
              }}
              testsAvailable={testsAvailable}
              onCardClick={(card) => {
                setApplicantProfileState(card)
                handleApplicantIds(card)
              }}
              activeAddButton={hasAccess}
              mode={status.id === 5 ? "complete" : "viewOnly"}
              onAddCandidate={() => {
                if (currentUserIsAdmin || canUseSegments) {
                  setAddNewCandidateModalOpen(true)
                } else {
                  window.location.href = `${window.location.href.split("/new")[0]}/applicants/new`
                }
              }}
              geniusActive={geniusActivation}
              mettlActive={mettlActive}
              handleApplicantsTotal={
                (columnsData) => {
                  setApplicantdIds(columnsData)
                }
              }
              kanbanSize={kanbanSize}
              onKanbanSizeChange={(size) => {
                setKanbanSize(size)
                sessionStorage.setItem('ats_kanban_size', size)
              }}
            />
               {!!applicantProfileState && (
                  <ApplicantProfile
                    showHiringMenu={hasLimitRegisterApplicants}
                    canEditTags={currentUserIsAdmin}
                    selectedApplicant={{
                      id: applicantProfileState.id,
                      columnId: applicantProfileState.column,
                      status: applicantProfileState.status
                    }}
                    open={!!applicantProfileState}
                    applicantsColumns={handleApplicantIds(applicantProfileState)}
                    appId={appId}
                    onApplicantMutated={handleApplicantMutated}
                    onClose={() => setApplicantProfileState(null)}
                    applicantSections={applicantSections}
                    currentUser={{
                      fullName: currentUser.name + currentUser.last_name,
                      avatar: currentUser.avatar || ''
                    }}
                    getCurrentApplicant={(currentApplicant, actionType) => {
                      if (actionType === 'START_HIRING') {
                        handleStartHiring(currentApplicant);
                      } else if (actionType === 'SEE_HIRING') {
                        // Para SEE_HIRING
                        const normalizedRequestTypes = normalizeRequestTypeData(currentApplicant);
                        const requestTypeId = normalizedRequestTypes && normalizedRequestTypes.length > 0
                          ? normalizedRequestTypes[0].id
                          : null;

                        setParticipant({
                          ...currentApplicant,
                          requestTypeData: requestTypeId,
                          uniqApplicantId: currentApplicant.uniqApplicant?.id
                        });
                        setShowRequestModal(true);
                      }
                    }}
                    registeredComponents={{
                      requestProfileComponent: RequestProfileComponent
                    }}
                  />
                )}

          </OutlookWrapper>
        </GoogleWrapper>
        {addNewCandidateModalOpen && (
          <ModalCreateCandidate
            open={addNewCandidateModalOpen}
            onCancel={() => setAddNewCandidateModalOpen(false)}
            onOk={(data) => {
              if(data === 'ADD_MANUALLY') {
                window.location.href = `${window.location.href.split("/new")[0]
                  }/applicants/new`
              } else {
                window.location.href = `${window.location.href.split("/new")[0]
                  }/applicants/new_from_segment`
              }
              setAddNewCandidateModalOpen(false)
            }}
          />
        )}
        <ModalUserColumns
          isModalVisible={!!showUserColumn}
          columnId={selectedColumn}
          setShowUserColumn={setShowUserColumn}
          onCancelModal={() => setShowUserColumn(false)}
          currentUser={currentUser}
          selectionProcessId={id}
        />
        <ClosingProcessReasonModal
          onCloseModal={() => setShowReasonModal(false)}
          showModal={showCloseReasonModal}
        >
          <ClosingReasonForm
            onSubmit={handleFinish}
            closingReasons={closingReasons}
          />
        </ClosingProcessReasonModal>
        <SuspendModal
          visible={showSuspendModal}
          setVisible={setSuspendModal}
          handlePause={handlePause}
        />
        <ActivateModal
          visible={activateModal}
          setVisible={setActivateModal}
          handleActivate={handleActivate}
          reactivate={closedProcess}
          loading={activateLoading}
        />
        <CandidatesCopyModalConponent
          open={copyModal}
          onCancel={() => {
            setCopyModal(false)
          }}
          showCopyForm={true}
          selectedRows={{
            selectedRowKeys: [participant ? participant.uniqApplicantId : undefined],
            allSelected: false,
            unselectedRowKeys: []
          }}
          applicantId={participant ? participant.id : undefined}
        />
        <OptionModal
          list={selectionProcessesList}
          type={1}
          handleAction={handleMove}
          active={moveModal}
          setActive={setMoveModal}
          multiple={false}
        />
        <OptionModal
          list={selectionProcessesList}
          type={1}
          handleAction={handleBulkMove}
          active={bulkMoveModal}
          setActive={setBulkMoveModal}
          multiple={true}
        />
        <DeleteModal
          handleAction={handleDelete}
          active={deleteModal}
          setActive={setDeleteModal}
        />
        {position?.value &&
          <ModalPositionInfo positionToken={position.value} visible={positionModal} onCancel={()=> setPositionModal(false)} />
        }
        {!mettlActive && Object.keys(rules) && (
          <FiltersViewerModal
            rules={rules}
            value={selectedColumn}
            openModal={showFiltersOnly}
            onChangeModal={(state) => setShowFiltersOnly(state)}
            hybridOptions={{
              universities: universities,
            }}
            hybridSearch={{
              universities: handleSearchUniversities
            }}
          />
        )}
        {mettlActive && showFiltersOnly && Object.keys(rulesTest) && (
          <FiltersViewerModal
            rules={rulesTest}
            value={selectedColumn}
            openModal={showFiltersOnly}
            onChangeModal={(state) => setShowFiltersOnly(state)}
            hybridOptions={{
              universities: universities,
            }}
            hybridSearch={{
              universities: handleSearchUniversities
            }}
          />
        )}
      </Suspense>
      {(requestModal || showRequestModal) && (
        <ATSWrapper>
          <Provider store={AppStore}>
            <RequestModalExternal
              id={participant?.requestTypeData}
              externalReference={participant?.id}
              visible={requestModal}
              title={"Iniciar Alta"}
              onClose={() => {
                setRequestModal(false);
              }}
              setResponse={handleStartRequest}
              registerPersonnelRegistrationForm={PersonnelRegistrationFormViewer}
              registerEmployeesForm={RegisterEmployeesFormViewer}
              formOptional={
                (props) => (
                  <FormOptionalSection
                    {...props}
                    initialData={props.initialData?.length ? props.initialData : applicantForm}
                  />
                )
              }
              parameters={
                participant ? humps.decamelizeKeys({
                  ...contratationData?.v1 || {},
                  ..._.omit(contratationData?.v2 || {}, _.isNull),
                  ..._.omit(contratationData?.payroll_contratation_data || {}, _.isNull),
                }) : null
              }
            />
          </Provider>
          <RequestModal
            id={participant?.workflowId}
            isOpen={showRequestModal}
            setIsOpen={setShowRequestModal}
            registerPersonnelRegistrationForm={
              PersonnelRegistrationFormViewer
            }
            registerEmployeesForm={RegisterEmployeesFormViewer}
            formOptional={FormOptionalSection}
          />
        </ATSWrapper>
      )}
      {/* Modal selector de workflow configurations para múltiples tipos de solicitud */}
      <Suspense fallback={null}>
        <WorkflowConfigurationSelectorModal
          visible={showRequestTypeSelectorModal}
          requestTypes={requestTypesOptions}
          onSelect={(workflowConfigurationId) => {
            if (pendingApplicant) {
              const selectedType = requestTypesOptions.find(t => t.id === workflowConfigurationId);
              setParticipant({
                ...pendingApplicant,
                requestTypeData: workflowConfigurationId,
                uniqApplicantId: pendingApplicant?.uniqApplicant?.id,
                selectedRequestTypeName: selectedType?.name
              });
              applicantsService.getApplicantForms(
                pendingApplicant.id,
                handleFormApplicant,
                (error) => {
                  console.error('Error fetching applicant forms:', error);
                  openNotificationWithIcon('error', 'Error al obtener los formularios del candidato');
                }
              );
              applicantsService.getContratationData(
                pendingApplicant.id,
                handleContratationData,
                (error) => {
                  console.error('Error fetching contratation data:', error);
                  openNotificationWithIcon('error', 'Error al obtener los datos de contratación');
                }
              );
            }
          }}
          onClose={() => {
            setShowRequestTypeSelectorModal(false);
            setPendingApplicant(null);
            setRequestTypesOptions([]);
          }}
        />
      </Suspense>
    </div>
  );
};

export default ATSKanbanNew;
